
import {defineComponent} from 'vue'
import {operationDialog,operationDialogVisible,confirmOperationDialog,finishOperationDialog} from '@/utils/operationDialog'
const FeedbackContent=defineComponent({props:['content'],setup:props=>()=>props.content})
export default defineComponent({components:{FeedbackContent},setup(){return {dialog:operationDialog,visible:operationDialogVisible,confirm:confirmOperationDialog,finish:finishOperationDialog}}})
